module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAKCAYAAABblxXYAAAAAXNSR0IArs4c6QAAAKFJREFUKBW1kDEOwkAMBCOghz/wh/QpyKOhoKHiAzwgUmoeQJGd5E4xitkOS86tMnsr+5pmrbPkWPqx/p6VYxi++C5cvgR9Cxrp2IbH0D4EXYNGOvaTn0QGNeu/1Ad1LcfwbHidtBPcl5S7zk/RHI6lvIa6N3OM0JSzKiuzOk/AOrUcw5NyJm3VRxyqp/o9q+XjGI6UE5qOv2RahiW9+5fQCTQvM1ogd7HcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/choose.png
// module id = bH0I
// module chunks = 1